import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import "./assets/scss/cconsent-bar.css";
import Disclaimer from "./components/Disclaimer";

function App() {
    return (
        <>
            <nav className="header">
                <div className="top-row">
                    <a className="logo-wrapper" href="https://www.skoda-auto.pl/" target="_self"></a>
                </div>
                <div className="bottom-row">
                    <a href="https://www.skoda-auto.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
                </div>
            </nav>

            <div className="main-container">
                <h1 className="form-title">Umów się na jazdę próbną</h1>
                
                <div className="form-copy">                    
                    <p>
                        W Škodzie każdy wybór jest dobry. Chcesz się przekonać? 
                        </p>
                    <p>Wskaż model, który chcesz przetestować, a my skontaktujemy się z Tobą telefonicznie, aby ustalić szczegóły spotkania.</p>
                </div>

                <div className="form-wrapper">
                    <ServiceForm />
                    <Disclaimer />
                </div>

            </div>
        </>
    );
}

export default App;
